import React from "react";
import { useGearstudioAuth } from "@src/providers/GearstudioAuthProvider";
import { useLocation, useNavigate } from "react-router-dom";

type NavbarProps = {
    showHistory: boolean;
    setShowHistory: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GearstudioNavbar = ({showHistory, setShowHistory} : NavbarProps) => {
    const { user, logout } = useGearstudioAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isHomeRoute = location.pathname === "/";
    const isFaqRoute = location.pathname === "/faq";

    const openCreateView = () => {
        setShowHistory(false);
        if (!isHomeRoute) {
            navigate("/");
        }
    };

    const openHistoryView = () => {
        setShowHistory(true);
        if (!isHomeRoute) {
            navigate("/");
        }
    };

    const openFaqView = () => {
        if (!isFaqRoute) {
            navigate("/faq");
        }
    };

    return (
        <div className="gs-nav w-full">
            <div className="w-full px-3 py-3 sm:px-4">
                <div className="flex flex-col gap-2 md:hidden">
                    <div className="flex flex-wrap items-center justify-end gap-2">
                        <p className="text-right text-sm text-[color:var(--gs-text-secondary)]">
                            Signed in as <span className="font-semibold">{user?.email}</span>
                        </p>
                        <button
                            type="button"
                            onClick={logout}
                            className="rounded-md border border-[color:var(--gs-border-subtle)] bg-[color:var(--gs-bg-surface-alt)] px-3 py-1.5 text-xs font-semibold text-[color:var(--gs-text-primary)] transition-colors hover:bg-[color:var(--gs-input-bg)]"
                        >
                            Logout
                        </button>
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium">
                        <button
                            type="button"
                            onClick={openCreateView}
                            className={`transition-colors hover:text-[color:var(--gs-text-primary)] ${isHomeRoute && !showHistory ? "text-[color:var(--gs-text-primary)] underline decoration-[color:var(--gs-accent-primary)] underline-offset-4" : "text-[color:var(--gs-text-secondary)]"}`}
                        >
                            New Design
                        </button>
                        <button
                            type="button"
                            onClick={openHistoryView}
                            className={`transition-colors hover:text-[color:var(--gs-text-primary)] ${isHomeRoute && showHistory ? "text-[color:var(--gs-text-primary)] underline decoration-[color:var(--gs-accent-primary)] underline-offset-4" : "text-[color:var(--gs-text-secondary)]"}`}
                        >
                            All Designs
                        </button>
                        <button
                            type="button"
                            onClick={openFaqView}
                            className={`transition-colors hover:text-[color:var(--gs-text-primary)] ${isFaqRoute ? "text-[color:var(--gs-text-primary)] underline decoration-[color:var(--gs-accent-primary)] underline-offset-4" : "text-[color:var(--gs-text-secondary)]"}`}
                        >
                            FAQ
                        </button>
                    </div>
                </div>

                <div className="max-md:hidden md:grid md:grid-cols-[1fr_auto_1fr] md:items-start md:gap-4">
                    <div />
                    <div className="flex items-center justify-center gap-6 text-sm font-medium">
                        <button
                            type="button"
                            onClick={openCreateView}
                            className={`transition-colors hover:text-[color:var(--gs-text-primary)] ${isHomeRoute && !showHistory ? "text-[color:var(--gs-text-primary)] underline decoration-[color:var(--gs-accent-primary)] underline-offset-4" : "text-[color:var(--gs-text-secondary)]"}`}
                        >
                            New Design
                        </button>
                        <button
                            type="button"
                            onClick={openHistoryView}
                            className={`transition-colors hover:text-[color:var(--gs-text-primary)] ${isHomeRoute && showHistory ? "text-[color:var(--gs-text-primary)] underline decoration-[color:var(--gs-accent-primary)] underline-offset-4" : "text-[color:var(--gs-text-secondary)]"}`}
                        >
                            All Designs
                        </button>
                        <button
                            type="button"
                            onClick={openFaqView}
                            className={`transition-colors hover:text-[color:var(--gs-text-primary)] ${isFaqRoute ? "text-[color:var(--gs-text-primary)] underline decoration-[color:var(--gs-accent-primary)] underline-offset-4" : "text-[color:var(--gs-text-secondary)]"}`}
                        >
                            FAQ
                        </button>
                    </div>
                    <div className="flex items-center justify-end gap-2">
                        <p className="max-w-[340px] truncate text-right text-sm text-[color:var(--gs-text-secondary)]">
                            Signed in as <span className="font-semibold">{user?.email}</span>
                        </p>
                        <button
                            type="button"
                            onClick={logout}
                            className="rounded-md border border-[color:var(--gs-border-subtle)] bg-[color:var(--gs-bg-surface-alt)] px-3 py-1.5 text-xs font-semibold text-[color:var(--gs-text-primary)] transition-colors hover:bg-[color:var(--gs-input-bg)]"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
